import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import showBasketItemStatus from "../../../../vietnamese/showBasketItemStatus"
import convertDateOverTime from '../../../../helpers/convertDateOverTime'

class BasketItem extends Component {
    render() {
        const { item, index, type = '' } = this.props
        if (!item) return null

        const { product_type, product_size, product_color, barcode, status, is_printed, is_shipped, overtime, meta = {} } = { ...item }
        const {factory = ''} = {...meta}
        const overtimeText = !!overtime ? convertDateOverTime(overtime) : '-'
        return (
            <tr className={classNames("BasketItem", status)}>
                <td>{index + 1}</td>
                <td>#{barcode}</td>
                {type === "combo_fac" && <td>{!!factory ? factory : ''}</td>}
                <td>
                    <span>{showBasketItemStatus(status)}</span>
                    {
                        !!is_shipped && <span className="badge badge-success ml-2">shipped</span>
                    }
                </td>
                <td>{is_printed ? 'Đã in' : 'Chưa in'}</td>
                <td>{product_type}</td>
                <td>{product_color}</td>
                <td>{product_size}</td>
                <td className='OverTime d-flex align-items-center flex-wrap-reverse' style={{ minWidth: 110 }}>
                    {overtime > 0 &&
                        <label
                            className='btn btn-sm mr-1 my-1'
                            style={{
                                background: 'rgb(255 77 80)',
                                color: 'white',
                            }}
                        >
                            Quá hạn
                        </label>
                    }
                    {overtime < 0 && overtime >= -1.5 &&
                        <label
                            className='btn btn-sm mr-1 my-1'
                            style={{
                                background: '#ffcd3a',
                                color: 'white',
                            }}
                        >
                            Sắp quá hạn
                        </label>
                    }
                    <span className={`mb-0 ${overtime > 0 ? 'text-danger' : overtime < 0 && overtime >= -1.5 ? 'text-warning' : ''}`}>
                        {overtimeText}
                    </span>
                </td>
            </tr>
        )
    }
}

BasketItem.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
}

export default BasketItem
